
<ng-container *ngIf="link$ | async as link">
	<ng-container *ngIf="linkInfo$ | async as linkInfo">
		<al-link-header [linkInfo]="linkInfo" [link]="link" [isMapperEnabled]="isMapperEnabled"></al-link-header>
		<div class="card">
			<div class="card-body">
				<al-link-edit
					#linkEdit
					[linkInfo]="linkInfo"
					[link]="link"
					[isMapperEnabled]="isMapperEnabled"
					[routeQueryParams]="routeQueryParams$ | async"
					(mapperAvailabilityRefreshRequested)="refreshMapperAvailability(link.id)">
				</al-link-edit>
			</div>
		</div>
	</ng-container>
</ng-container>
